import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const host = import.meta.env.VITE_REVERB_HOST || window.location.hostname;
const port = import.meta.env.VITE_REVERB_PORT || 8080;
const scheme = import.meta.env.VITE_REVERB_SCHEME || 'http';
const key = import.meta.env.VITE_REVERB_APP_KEY || import.meta.env.VITE_PUSHER_APP_KEY || 'mangitalia-key';

export function initEcho(tokenKey, channelPrefix) {
  const token = localStorage.getItem(tokenKey);
  if (!token) return null;

  const user = JSON.parse(localStorage.getItem(tokenKey.replace('_token', '_user')) || '{}');
  if (!user?.id) return null;

  const baseUrl = import.meta.env.VITE_API_BASE_URL === '' ? '' : (import.meta.env.VITE_API_BASE_URL || '/backend');

  const echo = new Echo({
    broadcaster: 'pusher',
    key,
    wsHost: host,
    wsPort: port,
    wssPort: port,
    forceTLS: scheme === 'https',
    encrypted: scheme === 'https',
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
    authEndpoint: `${baseUrl}/api/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      },
    },
  });

  return echo.private(`${channelPrefix}.${user.id}`);
}

export default initEcho;
